import React, { useEffect, useState } from "react"
import { TextTag } from "../../atoms"
import { PageHeader } from "../../molecules/PageHeader"
import { connect } from "react-redux"
import {
  viewOrder,
  saveUserAddress,
  resetCheckoutStatus,
  // setCheckoutHeaderMessage,
} from "../../redux/actionCreators/orderAndPayments"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import CheckoutContent, {
  CheckoutPriceBreakdown,
} from "../../components/CheckoutContent/CheckoutContent"
import CheckoutFooter from "../../components/CheckoutFooter/CheckoutFooter"
import CheckoutPartnerAway from "./CheckoutPartnerAway"
import "./CheckoutPage.scss"
import {
  BOTH,
  PARTNER_GO_BACK_FROM_CHECKOUT,
  BACK_FROM_CHECKOUT,
  GO_BACK_FROM_CHECKOUT,
  RESTAURANT_CHECKOUT_LABEL,
  GO_BACK_CONTENT,
  YOUR,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import {
  FirebaseService,
  FIREBASE_STATE_KEYS,
  FirebaseContext,
} from "../../firebase"
import { usePrevious } from "common-custom-hooks"
import BlockingModal from "../../components/BlockingModal/BlockingModal"
import { ArrowLeftOutlined } from "@ant-design/icons"
import { getUserAndPartnerCartDetails } from "./CheckoutUtils"
import {
  getFirstCaps,
  getGenderSpecificMessage,
  getPartnerNameorNickName,
  checkCheckoutPartnerAway,
} from "../../utils/helpers"
import RestaurantNameHeader from "../../components/RestaurantNameHeader/RestaurantNameHeader"
import { createCombinedOrderPriceBreakdown } from "../../utils/paymentHelper"

const CheckoutPage = props => {
  const {
    viewOrder,
    cartDetailsPartner1,
    cartDetailsPartner2,
    user,
    partner,
    isLoading,
    resetCheckoutStatus,
  } = props
  const [
    userCancellingModalVisibility,
    setuserCancellingModalVisibility,
  ] = useState(false)
  const [
    partnerCheckedOutModalVisibility,
    setpartnerCheckedOutModalVisibility,
  ] = useState(false)

  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )

  const partnerName = getPartnerNameorNickName(partnerState)
  const partnerGenderPosessive = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender"),
    "POSSESSIVE"
  )
  const partnerWant = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender"),
    "WANT"
  )
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const previousAcceptedRestaurant = usePrevious(acceptedRestaurant)
  const status = _.get(dateState, "payStatus")
    ? _.get(dateState.payStatus, "status", "")
    : ""
  const firebasePayStatus = _.get(dateState, "payStatus")
  const isPayingForBoth =
    _.get(dateState, "payStatus.userPickedTab") === _.get(user, "uuid", "") &&
    status === "BOTH"
  const showPartnerAway = checkCheckoutPartnerAway(partnerState, dateState)
  const isOrderCombined = _.get(
    dateState,
    FIREBASE_STATE_KEYS.IS_ORDER_COMBINED
  )
  const userActiveRoute = _.get(
    userState,
    FIREBASE_STATE_KEYS.ACTIVE_ROUTE,
    true
  )
  useEffect(() => {
    if (userActiveRoute !== "/checkout") props.history.push(userActiveRoute)
  })

  const isPartnerReadyForCheckout = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT
  )

  useEffect(() => {
    if (
      partnerState &&
      partnerState.activeRoute &&
      partnerState.activeRoute === "/plan-new-date" &&
      (isOrderCombined || isPayingForBoth)
    ) {
      FirebaseService.setActiveRoute("/plan-new-date")
      props.history.push("/plan-new-date")
      return
    }
    if (_.isEmpty(acceptedRestaurant)) {
      return
    }
    resetCheckoutStatus()
    const acceptedRestaurantId =
      acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]

    if (isPartnerReadyForCheckout === false) {
      setpartnerCheckedOutModalVisibility(true)
    } else {
      setpartnerCheckedOutModalVisibility(false)
    }
    if (
      acceptedRestaurantId &&
      !_.isEqual(previousAcceptedRestaurant, acceptedRestaurant)
    ) {
      viewOrder(true, acceptedRestaurantId)
    }
  }, [acceptedRestaurant, isPartnerReadyForCheckout])

  const cartDetails = getUserAndPartnerCartDetails(userState, partnerState)
  const userCartDetails = cartDetails["userDetails"]
  const partnerCartDetails = cartDetails["partnerDetails"]
  const combinedPrices = createCombinedOrderPriceBreakdown(
    userCartDetails.cart,
    partnerCartDetails.cart
  )
  // Handle Checkout Button Click
  const handleCheckOut = whomToPayFor => {
    const isPayForBoth = whomToPayFor === BOTH
    if (props.date) {
      FirebaseService.write(
        {
          ...firebasePayStatus,
          [userState.userDetails.uuid]: { state: "CONFIRM" },
          status: isOrderCombined ? "COMBINED" : isPayForBoth ? "BOTH" : "SELF",
          userPickedTab: isPayForBoth ? userState.userDetails.uuid : null,
        },
        `${FirebaseService.getDefaultPath()}${[FIREBASE_STATE_KEYS.PAY_STATUS]}`
      )
    }
    FirebaseService.setActiveRoute("/checkout/detail")
    props.history.push("/checkout/detail")
  }

  const showBlockingModal = () => {
    return (
      <>
        <BlockingModal
          withOptions
          disabled={firebasePayStatus && firebasePayStatus.status === "SELF"}
          title={GO_BACK_FROM_CHECKOUT}
          content={GO_BACK_CONTENT(partnerName)}
          blockingModalVisibility={userCancellingModalVisibility}
          continueHandler={async () => {
            if (userState && user) {
              await FirebaseService.write(
                false,
                `${FirebaseService.getDefaultPath()}${user.uuid}/${[
                  FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
                ]}`
              )
            }
            await FirebaseService.write(
              null,
              `${FirebaseService.getDefaultPath()}${[
                FIREBASE_STATE_KEYS.FIRST_USER_READY_FOR_CHECKOUT,
              ]}`
            )
            setuserCancellingModalVisibility(false)
            await FirebaseService.setActiveRoute("/confirm-date")
            props.history.push("/confirm-date")
          }}
          cancelHandler={() => setuserCancellingModalVisibility(false)}
        />
        <BlockingModal
          title={PARTNER_GO_BACK_FROM_CHECKOUT(
            _.get(props, "partner.display_name"),
            partnerGenderPosessive,
            partnerWant
          )}
          blockingModalVisibility={partnerCheckedOutModalVisibility}
          continueHandler={async () => {
            if (userState && user) {
              await FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${user.uuid}/${[
                  FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
                ]}`
              )
            }
            if (partnerState && partner) {
              await FirebaseService.write(
                null,
                `${FirebaseService.getDefaultPath()}${partner.uuid}/${[
                  FIREBASE_STATE_KEYS.READY_FOR_CHECKOUT,
                ]}`
              )
            }
            await FirebaseService.setActiveRoute("/confirm-date")
            props.history.push("/confirm-date")
          }}
        />
      </>
    )
  }

  const showPageHeader = () => {
    const fbPayStatus = _.get(firebasePayStatus, "status")
    return (
      <PageHeader
        onClick={() => setuserCancellingModalVisibility(true)}
        btnSize="small"
        disabled={
          (firebasePayStatus && fbPayStatus === "SELF") ||
          showPartnerAway ||
          fbPayStatus === "BOTH" ||
          fbPayStatus === "COMBINED"
        }
        icon={<ArrowLeftOutlined />}
        btnText={getFirstCaps(BACK_FROM_CHECKOUT)}
        headerText={RESTAURANT_CHECKOUT_LABEL}
      />
    )
  }

  const renderCombinedView = () => {
    return (
      <div className="checkout-combined">
        <div className="divide-user full-width">
          <CheckoutContent
            {...userCartDetails.cart}
            username={YOUR}
            className="You"
            isOrderCombined={isOrderCombined}
          />
        </div>
        <div className="divide-partner full-width">
          <CheckoutContent
            {...partnerCartDetails.cart}
            username={`${partnerName}'s`}
            className="partner"
            isOrderCombined={isOrderCombined}
          />
          <div className="checkout-price-breakdown">
            <CheckoutPriceBreakdown
              {...combinedPrices}
              isOrderCombined={isOrderCombined}
              customOrderWrapper="single-view"
            />
          </div>
        </div>
      </div>
    )
  }

  const renderSplitView = () => {
    return (
      <div className="checkout-container">
        <React.Fragment>
          <div className="divide-user">
            <CheckoutContent
              {...userCartDetails.cart}
              username="You"
              className="user"
            />
            <CheckoutPriceBreakdown
              {...userCartDetails.cart}
              isOrderCombined={isOrderCombined}
            />
          </div>
          <div className="divide-partner">
            <CheckoutContent
              {...partnerCartDetails.cart}
              username={partnerName}
              className="partner"
            />
            <CheckoutPriceBreakdown
              {...partnerCartDetails.cart}
              isOrderCombined={isOrderCombined}
            />
          </div>
        </React.Fragment>
      </div>
    )
  }

  const getCheckoutContent = () => {
    return (
      <React.Fragment>
        <CheckoutPartnerAway {...props} />
        {showBlockingModal()}
        <div className="order-receipt">
          {showPageHeader()}
          <RestaurantNameHeader restaurants={props.restaurants} />
          {cartDetailsPartner1 && cartDetailsPartner2 && (
            <div id="Checkout">
              {isOrderCombined ? renderCombinedView() : renderSplitView()}
            </div>
          )}
        </div>
        <CheckoutFooter
          payHandler={handleCheckOut}
          partner1Total={cartDetailsPartner1.total}
          partner2Total={cartDetailsPartner2.total}
          payStatus={firebasePayStatus}
          combinedPricesTotal={_.get(combinedPrices, "total", 0).toFixed(2)}
        />
      </React.Fragment>
    )
  }

  return <div id="CheckoutPage">{isLoading ? null : getCheckoutContent()}</div>
}

const mapStateToProps = state => {
  const {
    orderAndPayments: {
      cartDetailsPartner1,
      cartDetailsPartner2,
      isLoading,
      payStatus,
      partnerConfirmedCheckoutDetails,
      checkoutHeaderMessage,
    },
    invitePeople: { partnerDetails },
    auth: { user, partner },
    planDinner: { restaurants },
  } = state
  return {
    cartDetailsPartner1,
    cartDetailsPartner2,
    partnerDetails,
    user,
    partner,
    isLoading,
    payStatus,
    partnerConfirmedCheckoutDetails,
    restaurants,
  }
}
export default connect(mapStateToProps, {
  viewOrder,
  saveUserAddress,
  invitePartnerToChat,
  resetCheckoutStatus,
  // setCheckoutHeaderMessage,
})(CheckoutPage)
